import {
  REQUEST_LOCATIONS,
  RECEIVED_LOCATIONS,
  SHOW_ADD_LOCATION_FORM,
  CLOSE_ADD_LOCATION_FORM,
  UPDATE_LOCATION_FIELD,
  UPDATE_LOCATION_SUCCEDED,
  DELETE_LOCATION_SUCCEDED,
  CANCEL_LOCATION_IMAGE,
  CHANGE_LOCATION_IMAGE,
  CLOSE_LOCATION_CALENDAR,
  SHOW_LOCATION_CALENDAR,
  CHANGE_CALENDAR_VIEW,
  CHANGE_CALENDAR_DATE,
  REQUEST_BOOKINGS,
  RECEIVED_BOOKINGS,
  SHOW_SPINNER,
  MOVE_UP_SUCCEDED,
  MOVE_DOWN_SUCCEDED,
  UPDATE_LOCATIONS_FILTER,
  SHOW_AVATAR,
  UPDATE_HAS_TV,
  CHANGE_PAGE,
  UPDATE_BRIVO
} from '../actions/locations'

import {
  SHOW_AVAILABLE_DATE_FORM,
  CLOSE_ADD_AVAILABLE_DATE_FORM,
  UPDATE_AVAILABLE_DATE_FIELD,
  UPDATE_AVAILABLE_DATE_SUCCEDED,
  DELETE_AVAILABLE_DATE_SUCCEDED
} from '../actions/availableDates'

import {
  SHOW_AVAILABLE_TIME_SLOT_FORM,
  CLOSE_ADD_AVAILABLE_TIME_SLOT_FORM,
  UPDATE_AVAILABLE_TIME_SLOT_FIELD,
  UPDATE_AVAILABLE_TIME_SLOT_SUCCEDED,
  DELETE_AVAILABLE_TIME_SLOT_SUCCEDED,
  UPDATE_LAST_TIME
} from '../actions/availableTimeSlots'

import { SHOW_BOOKING_FORM, CLOSE_BOOKING_FORM, DELETE_BOOKING_SUCCEDED } from '../actions/bookings'

import { RECEIVED_COMPANIES } from '../actions/companies'

import { RECEIVED_BUILDINGS } from '../actions/buildings'

const locationsReducer = (state = { filter: { buildingId: ' ', companyId: ' ' } }, action) => {
  switch (action.type) {
    case SHOW_BOOKING_FORM:
      return {
        ...state,
        booking: action.booking
      }

    case CLOSE_BOOKING_FORM:
      return {
        ...state,
        booking: null
      }

    case DELETE_BOOKING_SUCCEDED:
      return {
        ...state,
        calendarLocation: action.location,
        booking: null
      }

    case SHOW_AVATAR:
      return {
        ...state,
        showAvatar: action.showAvatar
      }

    case SHOW_LOCATION_CALENDAR:
      return {
        ...state,
        calendarLocation: action.location,
        currentLocation: null
      }

    case UPDATE_LOCATIONS_FILTER:
      return {
        ...state,
        filter: { ...state.filter, [action.filter]: action.value },
        pageOrFilterChanged: true,
        pageNumber: 1
      }

    case CLOSE_LOCATION_CALENDAR:
      return {
        ...state,
        calendarLocation: null,
        currentLocation: null,
        bookings: null
      }

    case REQUEST_LOCATIONS:
      return {
        ...state,
        isFetching: true
      }

    case RECEIVED_LOCATIONS:
      return {
        ...state,
        isFetching: false,
        locationsFetched: true,
        locations: action.json.locations,
        totalLocationsAfterFilters: action.json.totalLocationsAfterFilters,
        pageOrFilterChanged: false
      }

    case REQUEST_BOOKINGS:
      return {
        ...state,
        bookingsFetched: false
      }

    case RECEIVED_BOOKINGS:
      return {
        ...state,
        bookingsFetched: true,
        bookings: action.json
      }

    case RECEIVED_BUILDINGS:
      return {
        ...state,
        buildingsFetched: true,
        buildings: action.json.buildings,
        buildingsCount: action.json.buildingsCount
      }

    case RECEIVED_COMPANIES:
      return {
        ...state,
        companiesFetched: true,
        companies: action.json.companies,
        companiesCount: action.json.companiesCount
      }

    case SHOW_ADD_LOCATION_FORM:
      return {
        ...state,
        currentLocation: action.location,
        showSpinner: false
      }
    case SHOW_SPINNER:
      return {
        ...state,
        showSpinner: true
      }

    case CLOSE_ADD_LOCATION_FORM:
      return {
        ...state,
        currentLocation: null
      }

    case UPDATE_LOCATION_FIELD:
      return {
        ...state,
        currentLocation: { ...state.currentLocation, [action.name]: action.value }
      }

    case MOVE_UP_SUCCEDED:
      let moveUpLocations = state.locations.map(location => {
        if (location.orderIndex == action.location.orderIndex && location._id && action.location._id) {
          location.orderIndex = location.orderIndex - 1
          return location
        } else if (location._id == action.location._id) {
          return action.location
        }
        return location
      })

      return {
        ...state,
        locations: moveUpLocations
      }

    case MOVE_DOWN_SUCCEDED:
      let moveDownLocations = state.locations.map(location => {
        if (location.orderIndex == action.location.orderIndex && location._id && action.location._id) {
          location.orderIndex = location.orderIndex + 1
          return location
        } else if (location._id == action.location._id) {
          return action.location
        }
        return location
      })

      return {
        ...state,
        locations: moveDownLocations
      }

    case UPDATE_LOCATION_SUCCEDED:
      let newLocations = state.locations.filter(location => {
        return location._id !== action.location._id
      })

      newLocations.push(action.location)

      return {
        ...state,
        currentLocation: null,
        locations: newLocations
      }

    case DELETE_LOCATION_SUCCEDED:
      let deleteLocations = state.locations.map(location => {
        if (location.orderIndex > action.location.orderIndex) {
          location.orderIndex = location.orderIndex - 1
          return location
        }

        return location
      })

      return {
        ...state,
        currentLocation: null,
        locations: deleteLocations.filter(location => {
          return location._id !== action.location._id
        })
      }

    case CANCEL_LOCATION_IMAGE:
      return {
        ...state,
        currentLocation: { ...state.currentLocation, newImage: null }
      }

    case UPDATE_HAS_TV:
      return {
        ...state,
        currentLocation: { ...state.currentLocation, hasTv: action.enabled }
      }

    case CHANGE_LOCATION_IMAGE:
      return {
        ...state,
        currentLocation: { ...state.currentLocation, newImage: action.image }
      }

    case CHANGE_CALENDAR_VIEW:
      return {
        ...state,
        calendarView: action.view
        // showAvatar: false
      }

    case CHANGE_CALENDAR_DATE:
      return {
        ...state,
        calendarDate: action.date
      }

    case SHOW_AVAILABLE_DATE_FORM:
      return {
        ...state,
        availableDate: action.availableDate
      }

    case CLOSE_ADD_AVAILABLE_DATE_FORM:
      return {
        ...state,
        availableDate: null
      }

    case UPDATE_AVAILABLE_DATE_FIELD:
      return {
        ...state,
        availableDate: { ...state.availableDate, [action.name]: action.value }
      }

    case UPDATE_AVAILABLE_DATE_SUCCEDED:
      return {
        ...state,
        availableDate: null,
        calendarLocation: action.location,
        locations: state.locations.map(location => (location._id === action.location._id ? action.location : location))
      }

    case DELETE_AVAILABLE_DATE_SUCCEDED:
      return {
        ...state,
        availableDate: null,
        calendarLocation: action.location,
        locations: state.locations.map(location => (location._id === action.location._id ? action.location : location))
      }

    case SHOW_AVAILABLE_TIME_SLOT_FORM:
      return {
        ...state,
        availableTimeSlot: action.availableTimeSlot
      }

    case CLOSE_ADD_AVAILABLE_TIME_SLOT_FORM:
      return {
        ...state,
        availableTimeSlot: null
      }

    case UPDATE_AVAILABLE_TIME_SLOT_FIELD:
      return {
        ...state,
        availableTimeSlot: { ...state.availableTimeSlot, [action.name]: action.value }
      }

    case UPDATE_AVAILABLE_TIME_SLOT_SUCCEDED:
      return {
        ...state,
        availableTimeSlot: null,
        calendarLocation: action.location,
        locations: state.locations.map(location => (location._id === action.location._id ? action.location : location))
      }

    case DELETE_AVAILABLE_TIME_SLOT_SUCCEDED:
      return {
        ...state,
        availableTimeSlot: null,
        calendarLocation: action.location,
        locations: state.locations.map(location => (location._id === action.location._id ? action.location : location))
      }

    case UPDATE_LAST_TIME:
      return {
        ...state,
        lastStartDate: action.lastStartDate,
        lastEndDate: action.lastEndDate
      }

    case CHANGE_PAGE:
      return {
        ...state,
        pageNumber: action.pageNumber,
        pageOrFilterChanged: true
      }

    case UPDATE_BRIVO:
      return {
        ...state,
        currentLocation: { ...state.currentLocation, brivo: action.value }
      }

    default:
      return {
        ...state
      }
  }
}

export default locationsReducer



// WEBPACK FOOTER //
// ./src/reducers/locations.js